<template>
    <div>
        <div v-if="obj.xinvalido" class="alert alert-danger" role="alert">
            <p class="text-center">{{ mi }}</p>
        </div>
        <div v-if="obj.xsuccess" class="alert alert-success" role="alert">
            <p class="text-center">{{ ms }}</p>
        </div>
        <div v-if="obj.xload" class="alert alert-warning" role="alert">
            <p class="text-center">{{ ml }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        msgInvalido: { type: String, required: false, default: "Revise los datos ingresados" },
        msgSuccess: { type: String, required: false, default: "Datos registrados exitosamente" },
        msgLoading: { type: String, required: false, default: "Cargando..." },
    },
    data() {
        return {
            obj: {
                xinvalido: false,
                xsuccess: false,
                xload: false,
            },
            mi: "",
            ms: "",
            ml: "",
        };
    },
    watch: {
        msgInvalido: function() {
            this.mi = this.msgInvalido;
        },
        msgSuccess: function() {
            this.ms = this.msgSuccess;
        },
        msgLoading: function() {
            this.ml = this.msgLoading;
        },
    },
    methods: {
        invalido(str) {
            this.obj.xinvalido = true;
            this.obj.xsuccess = false;
            this.obj.xload = false;
            if (str) this.mi = str;
        },
        success(str) {
            this.obj.xinvalido = false;
            this.obj.xsuccess = true;
            this.obj.xload = false;
            if (str) this.ms = str;
        },
        cargando(str) {
            this.obj.xinvalido = false;
            this.obj.xsuccess = false;
            this.obj.xload = true;
            if (str) this.ml = str;
        },
        reset() {
            this.obj.xinvalido = false;
            this.obj.xsuccess = false;
            this.obj.xload = false;
            this.ml = "Cargando...";
        },
    },
    mounted() {
        this.mi = this.msgInvalido;
        this.ms = this.msgSuccess;
        this.ml = this.msgLoading;
    },
};
</script>
